export default __webpack_public_path__ + "static/img/kydj@2x.ab5e71.png";